export default {
  production_suite: "Production Suite",
  production_suite_plus: "Production Suite+",
  alcolyzer_selzer: "Basic Suite",
  gas_analysis: "Packaging Suite",
  chemistry__acetic_acid: "Acetic Acid",
  chemistry__lactic_acid: "Lactic Acid",
  chemistry__fermentable_sugars: "Fermentable Sugars",
  chemistry__sulfur_dioxide: "Sulfur Dioxide",
  chemistry__free_amino_nitrogen: "Free Amino Nitrogen",
  chemistry__vicinal_diketones: "VDK",
  chemistry__acetaldehyde: "Acetaldehyde",
  simple_nutrition: "Nutrition Panel",
  simple_nutrition__polyphenols: "Polyphenol",
  simple_nutrition__starch: "Starch",
  microservices__pcr_bacteria_analysis: "Bacteria qPCR",
  microservices__pcr_yeast_analysis: "Yeast qPCR",
  microservices__pasteurization_analysis: "Pathogen Organisms",
  microservices__plate_analysis: "Plating (Single Media)",
  microservices__pcr_and_plate_analysis: "Plating (Comprehensive Media)",
  microservices__spoiler_micro_simple: "Spoiler Micro (Simple)",
  microservices__spoiler_micro_comprehensive: "Spoiler Micro (Comprehensive)",
  microservices__pasteurization_validation_simple: "Pasteurization Validation (Simple)",
  microservices__pasteurization_validation_comprehensive: "Pasteurization Validation (Comprehensive)",
  microservices__shelf_life_analysis: "Shelf Life Analysis",
  microservices__shelf_life_analysis_simple: "Shelf Life Analysis (Simple)",
  microservices__shelf_life_analysis_comprehensive: "Shelf Life Analysis (Comprehensive)",
  o2_co2_testing: "O2/CO2 Testing",
  cbd_thc_potency: "CBD/THC Potency",
  cbd_thc_potency_plus: "CBD/THC Potency+",
  cbd_thc_potency_plus_plus: "CBD/THC Potency++"
};
